import React, { useEffect } from 'react'
import { Props_SnippetStats } from './Stats.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const animateCounter = (
    counterElement: HTMLSpanElement,
    rangeStart: number = 0,
    rangeStop: number | null = null,
    timeDuration: number = 3000
) => {
    const dataSet: number = counterElement.dataset?.counter ? parseFloat(counterElement.dataset.counter) : 0
    const originalCounter: number = dataSet
    const end: number = rangeStop !== null ? rangeStop : originalCounter
    const range: number = end - rangeStart
    let timeStep: number = Math.abs(timeDuration / range)
    timeStep = Math.max(timeStep, 50)

    const timeStart = new Date().getTime()
    const timeEnd = timeStart + timeDuration
    let timer: number | undefined

    const run = () => {
        const timeNow = new Date().getTime()
        const timeRemaining = Math.max((timeEnd - timeNow) / timeDuration, 0)
        let displayValue: number

        if (originalCounter % 1 !== 0) {
            displayValue = parseFloat((end - timeRemaining * range).toFixed(1))
        } else {
            displayValue = Math.round(end - timeRemaining * range)
        }

        counterElement.innerHTML = displayValue.toLocaleString()
        if (displayValue === end) {
            clearInterval(timer)
        }
    }

    if (counterElement) {
        timer = window.setInterval(run, timeStep)
        run()
    }
}

const SnippetStats: React.FC<Props_SnippetStats> = (props) => {
    const { snippet, heading, content, repeatable_stat } = props
    
    const snippetID = Math.random().toString(36).substring(2, 10)
    const classSnippetTheme: string = snippet.theme.value ? `snippet-statistics--theme-${snippet.theme.value}` : ''
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-statistics__heading--${heading.visibility.value}` : ''

    useEffect(() => {
        const containers: NodeListOf<HTMLDivElement> = document.querySelectorAll('.snippet-statistics')
    
        containers.forEach((container: HTMLDivElement) => {
            const counters: NodeListOf<HTMLSpanElement> = container.querySelectorAll('.snippet-statistics__item-statistic')
            if (!('IntersectionObserver' in window)) return
    
            const config: IntersectionObserverInit = {
                root: null,
                rootMargin: '0px',
                threshold: 1,
            }
    
            const observer: IntersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return
    
                    const snippet = entry.target as HTMLSpanElement
                    if (snippet?.classList.contains('snippet-statistics__digits--ran')) return
    
                    animateCounter(snippet)
                    observer.unobserve(snippet)
                    snippet.classList.add('snippet-statistics__digits--ran')
                })
            }, config)
    
            counters.forEach((counterElement) => {
                observer.observe(counterElement)
            })
        })
    }, [])

    return (
        <section className={`snippet-statistics ${classSnippetTheme}`}>
            <div className="snippet-statistics__container">
                <div className="snippet-statistics__container-information">
                    <h2 className={`snippet-statistics__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                    { content.content?.value && <div className="snippet-statistics__content">{ Legacy_CompileMarkdown(content.content.value) }</div> }
                </div>
                <div className="snippet-statistics__container-items">
                { repeatable_stat.map((stat, index: number) => (
                    <div className="snippet-statistics__item" key={`snippet-statistics-${snippetID}-item-${index}`}>
                        <h3 className="snippet-statistics__item-heading">
                            { stat.prependUnit?.value && <span className="snippet-statistics__item-prepend">{stat.prependUnit.value}</span> }
                            { stat.statistic?.value && <span className="snippet-statistics__item-statistic" data-counter={stat.statistic.value}>{stat.statistic.value}</span> }
                            { stat.appendUnit?.value && <span className="snippet-statistics__item-append">{stat.appendUnit.value}</span> }
                        </h3>
                        { stat.content?.value && <div className="snippet-statistics__item-content">{ Legacy_CompileMarkdown(stat.content.value) }</div> }
                    </div>
                ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetStats